/* Looha — brand behaviour. Two things only: reveal-on-scroll, and the mobile
   sticky add-to-cart bar. Everything else is Dawn's. */

(function () {
  'use strict';

  /* ---- Reveal on scroll ------------------------------------------------- */

  function initReveal() {
    var targets = document.querySelectorAll('.lh-reveal:not(.is-in)');
    if (!targets.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    targets.forEach(function (el) {
      // Reveal anything already in view on load, so nothing sits hidden above
      // the point the user first scrolls to.
      var rect = el.getBoundingClientRect();
      if (rect.top < (window.innerHeight || 0) && rect.bottom > 0) {
        el.classList.add('is-in');
        return;
      }
      observer.observe(el);
    });

    // Safety net: a section must never stay invisible. If the observer never
    // fires for something (odd viewport, full-page screenshot tools, a missed
    // event), reveal everything still hidden after a short grace period.
    window.setTimeout(function () {
      document.querySelectorAll('.lh-reveal:not(.is-in)').forEach(function (el) {
        el.classList.add('is-in');
        observer.unobserve(el);
      });
    }, 1600);
  }

  /* ---- Sticky add-to-cart (mobile) -------------------------------------- */

  function initStickyAtc() {
    var bar = document.querySelector('[data-lh-sticky-atc]');
    if (!bar) return;

    var form = document.getElementById(bar.dataset.lhStickyAtc);
    var anchor = document.querySelector('[data-lh-atc-anchor]');
    if (!form || !anchor || !('IntersectionObserver' in window)) return;

    // Submitting the sticky button just fires the real product form, so
    // variant selection, quantity and Dawn's cart drawer all keep working.
    var trigger = bar.querySelector('[data-lh-sticky-submit]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.click();
      });
    }

    // Show the bar once the real add-to-cart has scrolled out of view.
    var observer = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -80px 0px' }
    );

    observer.observe(anchor);
  }

  /* ---- Homepage thread ---------------------------------------------------
     One continuous thread drawn down #MainContent that passes BEHIND the
     section images (which sit at z-index:2) and shows in the gaps, pulled
     through as the page scrolls. Desktop only; static under reduced motion. */

  function initThread() {
    var wrap = document.querySelector('[data-lh-thread]');
    if (!wrap || wrap.dataset.lhReady) return;
    var container = wrap.parentElement;
    var svg = wrap.querySelector('svg');
    var track = wrap.querySelector('.lh-thread__track');
    var drawn = wrap.querySelector('.lh-thread__drawn');
    if (!svg || !track || !drawn || !container) return;
    wrap.dataset.lhReady = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nodes = [];
    var len = 0;
    var samples = [];

    function rect(el) {
      var r = el.getBoundingClientRect();
      var c = container.getBoundingClientRect();
      return {
        x: r.left - c.left, y: r.top - c.top, w: r.width, h: r.height,
        cx: r.left - c.left + r.width / 2, cy: r.top - c.top + r.height / 2
      };
    }

    function ensureNodes() {
      if (nodes.length) return;
      var secs = [].slice.call(container.querySelectorAll(':scope > .shopify-section'));
      secs.slice(1).forEach(function (sec) {
        var n = document.createElement('i');
        n.className = 'lh-thread__node';
        wrap.appendChild(n);
        nodes.push({ el: n, sec: sec });
      });
    }

    function build() {
      ensureNodes();
      var mobile = !window.matchMedia('(min-width: 900px)').matches;
      var W = container.offsetWidth, H = container.offsetHeight;
      var G = mobile ? Math.max(9, W * 0.025) : Math.max(20, W * 0.03);
      var P = [];
      function gutter(y, dx) { P.push([G + (dx || 0), y]); }

      if (mobile) {
        // Stacked layout: the thread runs down the left margin and dips behind
        // each image (tiles, maker) as it passes, one after another.
        var targets = [].slice.call(container.querySelectorAll('.lh-tile, [data-lh-weave]')).map(rect);
        targets.sort(function (a, b) { return a.y - b.y; });
        var sY = targets.length ? targets[0].y - 90 : H * 0.12;
        P.push([G, sY]);
        targets.forEach(function (t) {
          var dipX = t.x + Math.min(t.w * 0.3, 110);
          gutter(t.y + t.h * 0.15, 3);
          P.push([dipX, t.y + t.h * 0.42]);
          P.push([dipX, t.y + t.h * 0.66]);
          gutter(t.y + t.h + 45, -3);
        });
        gutter(H - 40, 3); P.push([G, H]);
      } else {
        var tiles = [].slice.call(container.querySelectorAll('.lh-tile')).map(rect);
        var startY = tiles.length ? tiles[0].y - 120 : H * 0.15;
        P.push([G, startY]);
        var yEnd = startY;
        if (tiles.length) {
          var ty = tiles[0].y + tiles[0].h * 0.66;
          gutter(tiles[0].y - 70, 10);
          P.push([tiles[0].x - 26, ty]);
          tiles.forEach(function (t) { P.push([t.cx, ty]); });
          var last = tiles[tiles.length - 1];
          P.push([last.x + last.w + 26, ty]);
          gutter(ty + 150, -8); yEnd = ty + 150;
        }
        var mk = container.querySelector('[data-lh-weave]');
        var midY = mk ? rect(mk).y : H * 0.7;
        for (var y = yEnd + 320; y < midY - 140; y += 320) { gutter(y, 16 * Math.sin(y / 330)); }
        gutter(midY - 90, -10);
        if (mk) {
          var m = rect(mk);
          P.push([m.x - 24, m.y + m.h * 0.32]);
          P.push([m.cx, m.cy]);
          P.push([m.x + m.w + 24, m.y + m.h * 0.68]);
          gutter(m.y + m.h + 120, 6);
        }
        gutter(H - 40, -6); P.push([G, H]);
      }
      svg.setAttribute('width', W);
      svg.setAttribute('height', H);
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var d = 'M ' + P[0][0].toFixed(1) + ' ' + P[0][1].toFixed(1);
      for (var i = 1; i < P.length; i++) { d += ' L ' + P[i][0].toFixed(1) + ' ' + P[i][1].toFixed(1); }
      track.setAttribute('d', d); drawn.setAttribute('d', d);
      len = drawn.getTotalLength();
      drawn.style.strokeDasharray = len;
      drawn.style.strokeDashoffset = reduce ? 0 : len;
      samples = [];
      for (var s = 0; s <= len; s += 10) { samples.push(drawn.getPointAtLength(s)); }
      nodes.forEach(function (o) {
        var ny = rect(o.sec).y + 50; o.y = ny;
        var best = samples[0], bd = 1e9;
        samples.forEach(function (p) { var dd = Math.abs(p.y - ny); if (dd < bd) { bd = dd; best = p; } });
        o.el.style.left = best.x + 'px'; o.el.style.top = ny + 'px';
        if (reduce) o.el.classList.add('is-lit');
      });
    }

    function draw() {
      if (reduce) return;
      var H = container.offsetHeight;
      var top = container.getBoundingClientRect().top + window.scrollY;
      var mark = window.scrollY + window.innerHeight * 0.56 - top;
      drawn.style.strokeDashoffset = len * (1 - Math.max(0, Math.min(mark / H, 1)));
      nodes.forEach(function (o) { o.el.classList.toggle('is-lit', mark > o.y - 8); });
    }

    var tick = false;
    function onScroll() {
      if (!tick) { tick = true; requestAnimationFrame(function () { draw(); tick = false; }); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { build(); draw(); });
    window.addEventListener('load', function () { build(); draw(); });
    build(); draw();
  }

  function init() {
    initReveal();
    initStickyAtc();
    initThread();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }

  // Sections re-render on their own in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
